<template>
  <div :class="$style.container">
    <PlannerThumbnail
      :class="$style.image"
      :image="modelValue"
      :width="200"
      :height="200"
      v-if="preview"
    />
    <div :class="$style.input" v-else>
      <label
        :class="[
          $style.input__image,
          { [$style['input__image--disabled']]: disabled },
        ]"
      >
        <PlannerThumbnail
          :class="$style.image"
          :image="modelValue"
          :width="200"
          :height="200"
        />
        <input
          :class="$style.input__input"
          type="file"
          accept=".jpg, .png, .gif"
          :value="null"
          @input="handleInput"
          :disabled="disabled"
        />
      </label>
      <ul :class="[$style.input__text, $style.actions]">
        <li :class="$style.actions__item">
          <label :class="$style.action">
            変更する
            <input
              :class="$style.input__input"
              type="file"
              :value="null"
              accept=".jpg, .png, .gif"
              @input="handleInput"
              :disabled="disabled"
            />
          </label>
        </li>
        <li :class="$style.actions__item">
          <button
            :class="$style.action"
            type="button"
            @click.prevent="$emit('revert')"
            v-if="isChanged"
            :disabled="disabled"
          >
            元の画像に戻す
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import PlannerThumbnail from '@/components/atoms/PlannerThumbnail.vue'
import type { FlexImage } from '@/libs/utilities/FlexImage'

withDefaults(
  defineProps<{
    preview?: boolean
    modelValue?: Maybe<FlexImage>
    isChanged?: boolean
    disabled?: boolean
  }>(),
  {
    preview: false,
    modelValue: undefined,
    isChanged: false,
    disabled: false,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: File): void
  (event: 'revert'): void
}>()

const handleInput = (event: Event): void => {
  if (!(event.target instanceof HTMLInputElement)) {
    return
  }

  const [file] = event.target.files ?? []
  emit('update:modelValue', file)
}
</script>

<style lang="scss" module>
$thumbnail-size: 100px;

.image {
  width: $thumbnail-size;
  height: $thumbnail-size;
}

.input {
  display: grid;
  align-items: center;
  grid-template-columns: $thumbnail-size 1fr;

  &__input {
    display: none;
  }

  &__image {
    cursor: pointer;
    transition: opacity $transition-interaction;

    &:hover {
      opacity: 0.7;
    }

    &--disabled {
      cursor: wait;

      &:hover {
        opacity: 1;
      }
    }
  }
}

.actions {
  &__item {
    text-align: right;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.action {
  display: inline-flex;
  padding: 0;
  appearance: none;
  color: $color-text-and-object-accent-primary;
  font-size: 14px;

  &:hover {
    color: $color-text-and-object-accent-primary;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
